// @vue/component

import EmptyList from '@/components/Common/EmptyList';
import AddNewElementButton from '@/components/Common/AddNewElementButton';
import AddressBookItem from './AddressBookItem';
import AddressBookSearchPanel from './AddressBookSearchPanel';

export default {
  name: 'AddressBook',

  components: {
    EmptyList,
    AddressBookItem,
    AddNewElementButton,
    AddressBookSearchPanel,
  },

  props: {
    addressBook: {
      type: Object,
      default: () => ({}),
    },
    agentsList: {
      type: Array,
      default: () => [],
    }
  },

  data() {
    return {
      PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
      itemsPerPage: 20,
      currentPage: 1,
      filterBy: {
        description: '',
        num_a: '',
        isVip: '',
      },
    };
  },

  watch: {
    filterBy: {
      handler() {
        this.currentPage = 1;
      },
      deep: true,
    },
    itemsPerPage: {
      handler() {
        this.currentPage = 1;
      },
    },
  },

  async created() {
    window.addEventListener('resize', this.debounce(this.windowWidthChanged));
    this.windowWidthChanged();
  },

  destroyed() {
    window.removeEventListener('resize', this.windowWidthChanged);
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'addressBook/getList']);
    },
    filteredAddressBookItems() {
      let sortedByProject = this.addressBook.records.sort((a, b) => b.project_id - a.project_id);
      if (this.filterBy.description) {
        sortedByProject = sortedByProject.filter(item => item.description.toLowerCase().includes(this.filterBy.description.toLowerCase()));
      }
      if (this.filterBy.num_a) {
        sortedByProject = sortedByProject.filter(item => item.num_a.toLowerCase().includes(this.filterBy.num_a.toLowerCase()));
      }
      if (this.filterBy.isVip === true) {
        sortedByProject = sortedByProject.filter(item => item.vip === true);
      }
      if (this.filterBy.isVip === false) {
        sortedByProject = sortedByProject.filter(item => item.vip === false);
      }

      return sortedByProject;
    },

    itemsToRenderPerPage() {
      return this.filteredAddressBookItems.slice((this.currentPage - 1) * this.itemsPerPage, this.currentPage * this.itemsPerPage);
    },
  },
  methods: {
    handleChangePage(page) {
      this.currentPage = page;
    },

    changeFilterBy(value) {
      this.filterBy = value;
    },
    windowWidthChanged() {
      if (window.innerWidth >= 1295 && window.innerWidth < 1715) {
        this.PAGE_SIZE_OPTIONS = [9, 18, 27, 60, 99];
        this.itemsPerPage = 18;
      } else {
        this.PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
        this.itemsPerPage = 20;
      }
    },
    debounce(func, timeout = 300) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
      };
    },
  },
};
